import type { Contact } from '../../domain/contact';
import type { CollectedDataItem } from '../../domain/message';

import SharedDataExtractionService from './sharedDataExtractionService';

const createSalesforceLightningDataExtractionService = () => {
  const { extractName, extractContentByKey, extractCompanyName, extractCompanyDomainFromEmail } =
    SharedDataExtractionService;

  const extractValidDomain = (collectedInfo?: string[]): string | undefined => {
    if (!collectedInfo) {
      return;
    }
    const domainRegex = /(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}/;

    const result = collectedInfo.find((str) => domainRegex.test(str));
    return result?.match(domainRegex)?.[0];
  };

  const extractCompanyDomain = (collectedData: CollectedDataItem[]): string | undefined => {
    const collectedInfo = extractContentByKey(collectedData, 'Company Website');
    return extractValidDomain(collectedInfo as string[]);
  };

  const extractContactInfo = (collectedData: CollectedDataItem[]): Partial<Contact> => {
    const collectedInfo = extractContentByKey(collectedData, 'Contact info');
    const email = (collectedInfo as string[])?.find((infoItem) => infoItem?.includes('@'));
    return {
      name: extractName(collectedData),
      site: extractCompanyDomainFromEmail(email),
    };
  };

  const extractLeadInfo = (collectedData: CollectedDataItem[]): Partial<Contact> & { email: string } => {
    const collectedInfo = extractContentByKey(collectedData, 'Contact info');
    const email = (collectedInfo as string[])?.find((infoItem) => infoItem?.includes('@')) || '';

    return { name: extractName(collectedData), site: extractCompanyDomainFromEmail(email), email };
  };

  return { extractCompanyDomain, extractCompanyName, extractContactInfo, extractLeadInfo };
};

const SalesforceLightningDataExtractionService = createSalesforceLightningDataExtractionService();

export default SalesforceLightningDataExtractionService;
